<template>
    <div class="tabbar" id="tabbar">
        <div class="tabbar-item" :class="{'active': active == 'index'}">
            <a href="javascript:;" @click="go('/pages/homepage/Index')">
              <i class="icon icon-home"></i>
              <span>首页</span>
            </a>
        </div>

        <div class="tabbar-item" :class="{'active': active == 'categorys'}">
            <a href="javascript:;" @click="go('/pages/products/Categorys')">
              <i class="icon icon-cates"></i>
              <span>分类</span>
            </a>
        </div>

        <!-- 大玩家用户隐藏这个功能 -->
        <template v-if="!easyUser">
            <div class="tabbar-item" :class="{'active': active == 'products'}">
              <a href="javascript:;" @click="go('/pages/products/List?affordable=1')">
                <i class="icon icon-products"></i>
                <span>我能兑换</span>
              </a>
          </div>
        </template>
        

        <div class="tabbar-item" :class="{'active': active == 'cart'}">
          <a href="javascript:;" @click="go('/pages/orders/Cart')">
              <i class="icon icon-cart"></i>
              <span>购物车</span>
          </a>
        </div>

        <div class="tabbar-item" :class="{'active': active == 'setting'}">
            <a href="javascript:;" @click="go('/pages/setting/Index')">
              <i class="icon icon-setting"></i>
              <span>我的</span>
            </a>
        </div>

    </div>
</template>

<script>
import store from '../../api/store'
export default {
  props: ["active"],
  data() {
    return {
      easyUser: store.loginedUser.easyUser,
    }
  },
  methods: {
    go(url){
      this.$routerPush(this, url);
    }
  }
};
</script>

<style lang="less" scoped>
.tabbar {
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  right: 0;
  height: 14vw;
  background: white;
  font-size: 0;
  text-align: center;

  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-around;
}

.tabbar-item {
  display: inline-block;
  width: 19.5vw;
  padding-top: 2vw;
  a {
    display: inline-block;
    height: 100%;
    width: 100%;
  }

  .icon {
    width: 6vw;
    height: 6vw;
  }

  span {
    display: block;
    font-size: 3vw;
    margin-top: 1vw;
    color: #62605f;
  }

  .icon-home {
    background-image: url(../../assets/icon-home.png);
  }

  .icon-cates {
    background-image: url(../../assets/icon-cates.png);
  }

  .icon-products {
    background-image: url(../../assets/icon-products.png);
  }

  .icon-cart {
    background-image: url(../../assets/icon-cart.png);
  }

  .icon-setting {
    background-image: url(../../assets/icon-setting.png);
  }

  &.active {
    .icon-home {
      background-image: url(../../assets/icon-home-active.png);
    }

    .icon-cates {
      background-image: url(../../assets/icon-cates-active.png);
    }

    .icon-products {
      background-image: url(../../assets/icon-products-active.png);
    }

    .icon-cart {
      background-image: url(../../assets/icon-cart-active.png);
    }

    .icon-setting {
      background-image: url(../../assets/icon-setting-active.png);
    }

    span {
      color: @themeColor;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/common/TabBar.vue